<template>
  <!-- grayed out mobile  menu background -->
  <div :class="[mobileMenu ? 'flex' : 'hidden',
                'bg-black bg-opacity-20 z-40 fixed top-0 left-0 h-full w-full transform']"
       @click="mobileMenu = !mobileMenu">
  </div>
  <header :class="[mobileMenu ? 'z-40' : '', 'relative bg-main-darker', isLoggedIn ? 'flex' : 'hidden lg:flex']">
    <div :class="['logo-wrapper flex lg:flex-none',
                  'mx-3 sm:ml-6 sm:mr-5 lg:ml-12 lg:mr-10',
                  simpleNav ? 'w-40': '']"
         @click="mobileMenu = false">

      <a v-if="!isLoggedIn && simpleNav" href="https://talkatoo.com/" class="flex h-full">
        <img
          src="@/assets/images/logo_icon.svg"
          class="block lg:hidden h-10 m-auto"
          aria-label="Admin Portal Home" />
        <img
          src="@/assets/images/talkatoo_logo.svg"
          class="hidden lg:block h-14 w-40 m-auto"
          aria-label="Talkatoo homepage" />
      </a>
      <router-link v-else-if="isLoggedIn" to="/" class="h-full">
        <img
          src="@/assets/images/logo_icon.svg"
          class="block lg:hidden h-10 m-auto"
          aria-label="Admin Portal Home"
        />
        <img v-if="simpleNav"
             src="@/assets/images/talkatoo_logo.svg"
             class="hidden lg:block h-14 w-40 m-auto"
             aria-label="Admin Portal Home"
        />
      </router-link>
    </div>
    <!-- left-hand section for Greeting -->
    <div v-if="isLoggedIn && !simpleNav" class="hidden lg:flex flex-col justify-center ">
      <span class=" text-lg hidden xl:block">
        <TransitionGroup name="fade" appear>
          <span v-if="$store.getters.getUserProfile.firstName != ''" class="fade-duration">
            {{ greeting }}
          </span>
          <span v-if="$store.getters.getUserProfile.firstName" class="fade-duration">
            {{ $store.getters.getUserProfile.firstName }}
          </span>
        </TransitionGroup>
      </span>

      <span class=" text-base font-semibold">
        {{ greetingStatus }}
      </span>
    </div>
    <!-- Right-hand section for help/ logout etc -->
    <nav v-if="isLoggedIn && !simpleNav" class="flex flex-grow justify-end">
      <div :class="['hidden lg:flex pr-12 lg:border-l', simpleNav ? 'pr-24' : '']">

        <!-- notification icon -->
        <div v-if="false && isLoggedIn && !simpleNav" class="border-x px-7 flex flex-col justify-center">
          <BaseIconDropdown icon="notifications" :notifCount="notifCount" class="text-4xl text-gray-400 h-12 w-12">
            <div class="notification" @click="notifCount++"> notifications
            </div>
            <div class="notification"> will
            </div>
            <div class="notification"> be
            </div>
            <div class="notification"> listed
            </div>
            <div class="notification"> here
            </div>
          </BaseIconDropdown>
        </div>

        <!-- initials/pfp icon -->
        <div v-if="!simpleNav" class="flex m-auto ml-2">
          <Transition @before-enter="setEnterWidth" @enter="setTransitionWidth">
            <div v-if="$store.getters.getUserProfile.email" id="profile-card" class="flex transition-all duration-250 overflow-x-hidden">
              <div class="flex mr-2">
                <img v-if="userProfile?.profilePhoto"
                     :src="`https://storage.googleapis.com/assets.talkatoo.ai/profile-photos/${userProfile.profilePhoto}`"
                     class="block min-h-[4.25rem] min-w-[4.25rem] h-16 w-16 p-1
                          aria-selected:border-3 aria-selected:border-main-alt aria-selected:rounded-sm" />
                <div v-else class="block my-auto">
                  <BaseIcon
                    themeName="main"
                    themeSuffix="alt"
                    :text="initials"
                    diameter="4"
                    class="cursor-pointer"
                    @action="toProfile" />
                </div>
              </div>
              <!-- Name, email edit profile -->
              <div class="flex flex-col mr-4">
                <div class="font-roboto flex flex-col flex-grow pt-2 cursor-pointer" role="button"
                     @click="toProfile">
                  <span class="clamp-name text-lg font-light leading-4">
                    {{ fullName }}
                  </span>
                  <div v-if="$store.getters.getUserProfile.email" class=" text-sm font-medium whitespace-nowrap">
                    {{ $store.getters.getUserProfile.email }}
                  </div>
                  <RouterLink v-if="$store.getters.getUserProfile.email" id="your-profile-nav" to="/profile"
                              class="mt-auto mb-2 text-xs font-bold text-main-alt underline">
                    Edit Profile
                  </RouterLink>
                </div>
              </div>
            </div>
          </Transition>
          <!-- logout dropdown -->
          <div class="my-auto">
            <BaseDropdown :id="'logout-dropdown'" menuX="-translate-x-1/2">
              <a id="logout-button"
                 class="hover:no-underline text-base hover:bg-gray-200"
                 :disabled="isClicked ?? undefined"
                 @click="logout">
                Logout
              </a>
            </BaseDropdown>
          </div>
        </div>
      </div>
      <div v-if="!simpleNav" class="lg:hidden flex">
        <button class="text-base text-white m-auto" @click="mobileMenu = !mobileMenu">
          Menu
        </button>
        <div class="flex flex-col justify-center pr-3 sm:pr-4">
          <BaseIcon
            class="cursor-pointer"
            themeName="neutral" themeSuffix="lighter"
            :icon="mobileMenu ? 'close' : 'menu'"
            :diameter="2"
            :borderWidth="2"
            @action="mobileMenu = !mobileMenu" />
        </div>
        <!-- mobile menu list -->
        <Transition name="fade">
          <div v-if="mobileMenu" :class="['fade-duration', mobileMenu ? 'flex' : 'hidden',
                                          'bg-white w-screen flex-col z-50 absolute bottom-0 left-0 transform translate-y-full']"
               @click="mobileMenu = !mobileMenu">
            <!-- provisioning items -->

            <template v-if="isProvisioning">
              <RouterLink
                class="mobile-link pl-4 xs:pl-10 sm:pl-20 no-underline border-t text-2xl py-6 font-semibold" to="/getting-started">
                <div class="mr-5">
                  <BaseIcon class="m-auto" text="HM" icon="home" themeName="rare2" diameter="2.3" />
                </div>
                Getting Started
              </RouterLink>
            </template>
            <template v-else>
              <RouterLink
                class="mobile-link pl-4 xs:pl-10 sm:pl-20 no-underline border-t text-2xl py-6 font-semibold" to="/dashboard">
                <div class="mr-5">
                  <BaseIcon class="m-auto" text="HM" icon="home" themeName="rare2" diameter="2.3" />
                </div>
                Dashboard
              </RouterLink>
              <RouterLink class="mobile-link pl-4 xs:pl-10 sm:pl-20 no-underline text-2xl py-6 font-semibold" to="/notes/">
                <div class="mr-5">
                  <BaseIcon class="m-auto" text="SN" img="notebook_icon_rare2.svg" themeName="rare2" diameter="2.3" />
                </div>
                Talkatoo Notes
              </RouterLink>
              <!-- Admin pages -->
              <RouterLink v-if="userPerms.user_management || userPerms.billing_management"
                          class="mobile-link pl-4 xs:pl-10 sm:pl-20 no-underline text-2xl py-6 font-semibold" to="/admin-dashboard">
                <div class="mr-5">
                  <BaseIcon class="m-auto" text="HM" icon="supervisor_account" themeName="rare2" diameter="2.3" />
                </div>
                Admin Dashboard
              </RouterLink>

              <RouterLink v-if="userPerms.user_management"
                          class="mobile-link pl-6 xs:pl-14 sm:pl-32 bg-pastel-green-light text-2xl py-6 font-semibold" to="/user-management">
                <i class="material-icons m-auto mx-4 text-gray-400 no-underline"> account_circle </i>
                Users
              </RouterLink>

              <RouterLink v-if="userPerms.billing_management"
                          class="mobile-link pl-6 xs:pl-14 sm:pl-32 bg-pastel-green-light text-2xl py-6 font-semibold" to="/subscription">
                <i class="material-icons m-auto  mx-4 text-gray-400 no-underline"> credit_card </i>
                Subscription
              </RouterLink>

              <RouterLink v-if="userPerms.billing_management"
                          class="mobile-link pl-6 xs:pl-14 sm:pl-32 bg-pastel-green-light text-2xl py-6 font-semibold" to="/billing-history">
                <i class="material-icons m-auto mx-4 text-gray-400"> receipt </i>
                Billing History
              </RouterLink>
            </template>

            <!-- users pages -->
            <RouterLink to="/settings" class=" pl-4 xs:pl-10 sm:pl-20 text-2xl py-6 font-semibold">
              <div class="mr-5">
                <BaseIcon class="m-auto" text="ST" icon="settings" themeName="rare2" diameter="2.3" fontSize="1.5" />
              </div>
              Settings
            </RouterLink>

            <RouterLink class=" pl-4 xs:pl-10 sm:pl-20 text-2xl py-6 font-semibold" to="/profile">
              <div class="mr-5">
                <BaseIcon class="m-auto" :text="initials" themeName="rare2" diameter="2.3" fontSize="0.875" />
              </div>
              Your Profile
            </RouterLink>
            <!-- logout button -->
            <button class="flex pl-4 xs:pl-10 sm:pl-20 text-2xl py-6 font-semibold" @click="logout">
              <div class="mr-5">
                <BaseIcon class="m-auto" icon="logout" themeName="rare2" diameter="2.3" fontSize="1.4" />
              </div>
              <span class="text-main-alt font-semibold text-2xl">Logout </span>
            </button>
          </div>
        </Transition>
      </div>
    </nav>
  </header>
</template>

<script>
import BaseIcon from "Components/ui/BaseIcon";
import BaseDropdown from "Components/ui/BaseDropdown";
import BaseIconDropdown from "Components/ui/BaseIconDropdown";

export default {
  name: "TheHeading",
  components: {
    BaseIcon,
    BaseDropdown,
    BaseIconDropdown,
  },
  data () {
    return {
      loading: true, // for notification loading
      isClicked: false,
      mobileMenu: false,
      notifCount: 0,
      windowWidth: window.innerWidth,
    };
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    userProfile () {
      return this.$store.getters.getUserProfile;
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
    userPerms () {
      return this.$store.getters.getUserPerms;
    },
    featureFlags () {
      return this.$store.getters.getFeatureFlags;
    },
    isProvisioning () {
      return this.$store.getters.getSubscriptionState === "provisioning";
    },
    fullName () {
      if (this.userProfile.firstName !== undefined &&
        this.userProfile.lastName !== undefined) {
        return this.userProfile.firstName + ' ' + this.userProfile.lastName;
      } else {
        return "";
      }
    },
    simpleNav () {
      return this.$route.meta.simpleNav;
    },
    greeting () {
      const ToD = new Date().getHours();
      let Greeting = "Good morning, ";
      if (ToD > 19) Greeting = "Good evening, ";
      if (ToD > 12) Greeting = "Good afternoon, ";
      return `${Greeting}`;
    },
    // placeholder function to update heading with messages to the user
    greetingStatus () {
      return "Save time with Talkatoo!";
    },
    initials () {
      //testing first and lastName for undefined
      let firstName = "";
      let initials = "";
      let storeFirstName = this.userProfile.firstName;
      let storeLastName = this.userProfile.lastName;
      let storeEmail = this.userProfile.email;

      if (storeFirstName) {
        firstName = storeFirstName.trim();
        //setting initials with name sections
        if (firstName.length > 0) {
          initials += firstName[0].toUpperCase();
        }
      }
      let lastName = "";
      if (storeLastName) {
        lastName = storeLastName.trim();
        //setting initials with name sections
        if (lastName.length > 0) {
          initials += lastName[0].toUpperCase();
        }
      }
      let email = "";
      if (initials === "") {
        if (storeEmail) {
          email = storeEmail.trim();
          if (email.length > 0) {
            initials += email[0].toUpperCase();
          }
        }
      }
      return initials;
    },
  },
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth;
      this.setTransitionWidth(document.getElementById("profile-card"));
      if (window.innerWidth > 1024) {
        this.mobileMenu = false;
      }
    },
    toProfile () {
      this.$router.push("/profile").catch((err) => {
        console.log(err);
      });
    },
    logout () {
      this.isClicked = true;
      this.$store
        .dispatch("logout")
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isClicked = false;
        });
    },

    // before inital render
    setEnterWidth (el) {
      el.style.maxWidth = "0px";
    },
    // called one frame after the element is inserted.
    setTransitionWidth (el, done) {
      let width = 0;
      for (var i = 0; i < el.childElementCount; i++) {
        width += el.children[i].clientWidth + 16;
      }
      this.$nextTick(() => {
        el.style.maxWidth = `${width}px`;
      });
      if (done) done();
    },
  },
};
</script>

<style scoped>
.mobile-link {
  text-decoration: none !important;
}

header {
  @apply h-14;
}

@media (min-width: 1024px) {
  header {
    height: var(--header-h);
    @apply bg-white;
  }
}

@media (min-width: 1024px) {
  .logo-wrapper {
  }
}

@media (min-width: 1024px) {
  nav {
    @apply bg-white;
  }
}

.heading-text {
  vertical-align: middle;
  margin: auto;
}

.notification {
  @apply text-base;
  @apply text-neutral-darker;
  @apply py-1;
  @apply px-1;
}

.fade-duration {
  transition-duration: 0.1s;
}

.clamp-name {
  min-width: 10rem;
  max-width: 16em;
  display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>